module.exports = __webpack_public_path__ + "img/ic_fan.89f2a43b.png";